import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxMessageComponent } from './checkbox-message/checkbox-message.component';
import { SharedModule } from '../../shared/shared.module';
import { IconsModule } from '../../icons/icons.module';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { CustomToastrComponent } from './custom-toastr/custom-toastr.component';


@NgModule({
  declarations: [
    CheckboxMessageComponent,
    ErrorMessageComponent,
    CustomToastrComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,
  ],
  exports: [
    CheckboxMessageComponent,
    CustomToastrComponent
  ],
})
export class ToastrTemplatesModule { }
